import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  TOAST_KEY = 'global-toast';
  STICKY = false;

  constructor(private msgService: MessageService) {}

  async showSuccessToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'success');
  }

  async showInfoToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'info');
  }
  async showWarnToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'warn');
  }

  async showErrorToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'error');
  }

  async showApiError(options: {
    notMappedSummary: string;
    notMappedDetail: string;
    mappedApiSummary: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apiError: any;
  }): Promise<void> {
    if (options.apiError?.error?.statusCode === HttpStatusCode.ImATeapot) {
      this.showToast(
        options.mappedApiSummary,
        options.apiError?.error?.message,
        'error',
      );
    } else {
      this.showToast(
        options.notMappedSummary,
        options.notMappedDetail,
        'error',
      );
    }
  }

  async showToast(
    summary: string,
    detail: string,
    severity: string,
  ): Promise<void> {
    this.msgService.add({
      key: this.TOAST_KEY,
      severity: severity,
      summary: summary,
      detail: detail,
      sticky: this.STICKY,
      life: 3000,
    });
  }
}
